import { Fade, Slide } from "react-awesome-reveal";
import votersync_about from "../../assets/shopping.png";
import Image1 from "../../assets/products/EcommerseDashboard/Login.png";
import Image2 from "../../assets/products/EcommerseDashboard/Dashboard.png";
import Image3 from "../../assets/products/EcommerseDashboard/Product.png";
import Image4 from "../../assets/products/EcommerseDashboard/DiscountCpns.png";
import Image5 from "../../assets/products/EcommerseDashboard/Orders.png";
import Image7 from "../../assets/products/EcommerseDashboard/Category.png";
import Image8 from "../../assets/products/EcommerseDashboard/Coupons.png";
import Image9 from "../../assets/products/EcommerseDashboard/Banner.png";
import Image10 from "../../assets/products/EcommerseDashboard/Support.png";
import Image11 from "../../assets/products/EcommerseDashboard/Users.png";
import ImageSlider from "../common/ImageSlider";
import "./index.css";

import DashboardIcon from "../../assets/VoterSync/ModulesDashboard/Dashboard.svg";
// import AuditIcon from "../../assets/VoterSync/ModulesDashboard/audit.svg";
import ProductsIcon from "../../assets/VoterSync/ModulesDashboard/Products.svg";
import CouponsIcon from "../../assets/VoterSync/ModulesDashboard/Coupons.svg";
import BannerIcon from "../../assets/VoterSync/ModulesDashboard/Banner.svg";
import CunstomerIcon from "../../assets/VoterSync/ModulesDashboard/Customer.svg";
import OrdersIcon from "../../assets/VoterSync/ModulesDashboard/Orders.svg";
import SupportIcon from "../../assets/VoterSync/ModulesDashboard/Support.svg";
import UsersIcon from "../../assets/VoterSync/Modules/users.png";

import Video1 from "../../assets/VoterSync/EcommerceVideos/DiscountAndCoupons.mp4";
import Video2 from "../../assets/VoterSync/EcommerceVideos/Product.mp4";
import Video3 from "../../assets/VoterSync/EcommerceVideos/Users.mp4";
import Video4 from "../../assets/VoterSync/EcommerceVideos/Support.mp4";
import Video5 from "../../assets/VoterSync/EcommerceVideos/Banner.mp4";
import PlayIcon from "../../assets/play-btn.svg";

import { Dialog, IconButton } from "@mui/material";
import { uniqueId } from "lodash";
import { useState } from "react";
import GotoTop from "../common/GotoTop";
import MultiCarousel from "../common/MultiCarousel";

import ContactCTA from "../contact/contactCTA";

const VThumb1 = Image8;
const VThumb2 = Image3;
const VThumb3 = Image9;
const VThumb4 = Image10;
const VThumb5 = Image11;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 575 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 575, min: 0 },
    items: 1,
  },
};

const EcommerceDashboard = () => {
  const data = [
    {
      img: Image1,
      alt: "Image1",
    },
    {
      img: Image2,
      alt: "Image2",
    },
    {
      img: Image7,
      alt: "Image7",
    },
    {
      img: Image5,
      alt: "Image5",
    },
    {
      img: Image3,
      alt: "Image3",
    },
    {
      img: Image4,
      alt: "Image4",
    },
  ];

  const json = [
    {
      title: <>Dashboard</>,
      description: (
        <>
          Centralized view of active products, order status, customer count, coupons,
          and pending support tickets.
        </>
      ),
    },
    {
      title: <>Products</>,
      description: (
        <> Manage all available products with details like measurements and stock levels.
          Easily add, edit, or delete products as per need.</>
      ),
    },
    {
      title: <>Categories</>,
      description: (
        <>Manage product categories and subcategories to ensure better organization, control, and overall product behavior.</>
      ),
    },
    {
      title: <>Discounts & Coupons</>,
      description: <> Manage and configure discounts and coupon codes.
        Add or edit discounts by defining the discount type, percentage value,
        coupon code, and related details. This section helps confirm and control
        the actual discount applied.</>,
    },
    {
      title: <>Banner</>,
      description: (
        <>
          In the Banner section, you can add product banners in image or video format. You can also manage banners by adding, editing, or deleting them as needed.
        </>
      ),
    },
    {
      title: <>Customers</>,
      description: (
        <>
          View complete customer details in one place. Administrators and coordinators can easily navigate the section and make limited edits to customer information when required.
        </>
      ),
    },
    {
      title: <>Orders</>,
      description: (
        <>View and manage all order-related details in one place. This section shows order status (placed or failed), complete order information, payment details, and allows uploading relevant documents for each order.</>
      ),
    },
    {
      title: <>Support</>,
      description: (
        <>The Support module allows users to view, track, and resolve customer support tickets with details like customer info, messages, ticket status, and resolution.</>
      ),
    },
  ];

  const modules = [
    {
      title: "Dashboard",
      img: DashboardIcon,
    },
    {
      title: "Products",
      img: ProductsIcon,
    },
    {
      title: "Discounts & Coupons",
      img: CouponsIcon,
    },
    {
      title: "Banner",
      img: BannerIcon,
    },
    {
      title: "Customers",
      img: CunstomerIcon,
    },
    {
      title: "Orders",
      img: OrdersIcon,
    },
    {
      title: "Support",
      img: SupportIcon,
    },
    {
      title: "Users",
      img: UsersIcon,
    },
  ];

  const videoData = [
    {
      node: <RenderVideo title={"Users"} src={Video3} poster={VThumb5} />,
    },
    {
      node: <RenderVideo title={"Coupons"} src={Video1} poster={VThumb1} />,
    },
    {
      node: <RenderVideo title={"Product"} src={Video2} poster={VThumb2} />,
    },
    {
      node: <RenderVideo title={"Banner"} src={Video5} poster={VThumb3} />,
    },
    {
      node: <RenderVideo title={"Support"} src={Video4} poster={VThumb4} />,
    },
  ];

  const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
      e.currentTarget?.href.split("#")[1]
    );

    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="pt-4">
      <div className="md:flex ec-ecommerse md:h-[400px] ">
        <section className="flex flex-col justify-center">
          <div className="text-center ec-title flex justify-center font-semibold">
            <Fade triggerOnce>
              <p className="w-fit text-6xl md:text-7xl text-[var(--dark-blue)] leading-none mb-4">E-Commerce Dashboard</p>
            </Fade>
          </div>

          {/* <div className="md:flex bg-TransBillbook md:h-[400px] ">
      <section className="flex flex-col justify-center">
        <div className="text-center tb-title text-6xl md:text-7xl flex justify-center font-semibold">
          <Fade triggerOnce>
            <p className="w-fit text-[var(--dark-blue)] leading-[1.5]">
              TransBillbook
            </p>
          </Fade>
        </div> */}

          <div className="text-center font-bold tracking-widest text-xl md:text-2xl bg-[var(--dark-blue)] text-white py-2">
            <Fade triggerOnce delay={400}>
              <span>The complete E-Commerce Management Dashboard</span>
            </Fade>
          </div>
        </section>
        <div className="md:w-[65%] slider-container bg-[var(--dark-blue)] flex justify-center">
          <div className="w-full max-md:mb-[40px]">
            <Fade triggerOnce className="h-full relative" delay={600}>
              <ImageSlider data={data} />
            </Fade>
          </div>
        </div>
      </div>

      <div className="w-full px-5 sm:max-lg:px-2 my-7 sm:my-14">
        <p className="text-center mb-4 md:mb-0 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
          <Fade
            triggerOnce
            className="h-full relative text-[var(--dark-blue)] mb-4"
            delay={610}
          >
            About Our Platform
          </Fade>
        </p>

        <div className="lg:flex lg:gap-2 w-full">
          <div className="w-full">
            <div className="w-full">
              <Fade triggerOnce className="h-full relative" delay={610}>
                <img
                  src={votersync_about}
                  // className="lg:min-w-[600px] animate-on-appear"
                  className="align-middle mx-auto
                  w-[260px]
                  sm:w-[330px]
                  md:w-[390px]
                  lg:w-[480px]
                  h-auto
                  animate-on-appear"
                />
              </Fade>
            </div>
          </div>

          <div>
            <Fade triggerOnce className="h-full relative" delay={650}>
              <div className="flex flex-col justify-center ec-about-us-content h-full font-notosans text-md sm:text-xl font-semibold text-[#333e49]">
                <p className="mb-6">
                  The E-Commerce Dashboard is built to streamline and centralize online business
                  operations, providing a powerful and intuitive platform to manage products,
                  orders, customers, and promotional activities with ease.
                </p>

                <p className="mb-4">
                  <strong>How we can support your growth:</strong>
                </p>

                <ul className="mb-6 list-disc pl-6 space-y-2">
                  <li>
                    <strong>Custom B2B Dashboards:</strong> Centralize wholesale orders, real-time
                    inventory levels, and credit limits for your distributors.
                  </li>
                  <li>
                    <strong>Dedicated Mobile Applications:</strong> Enable your sales teams and
                    distributors to place orders, check stock, and view catalogs on the go.
                  </li>
                  <li>
                    <strong>Industry-Specific Logic:</strong> Specialized features for bulk pricing
                    tiers, fragrance categories, and secure shipping logistics.
                  </li>
                </ul>

                <p>
                  We have a proven track record of delivering high-performance tools that reduce
                  administrative overhead and increase sales velocity for B2B players in this
                  specific industry.
                </p>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      <div className="keyh-main-wrapper w-full px-5 sm:px-24 sm:my-14">
        <div className="keyh-wrapper">
          <div className="keyh-box py-4 sm:py-6">
            <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
              <Fade
                triggerOnce
                className="h-full relative text-[var(--dark-blue)]"
                delay={700}
              >
                Salient Features
              </Fade>
            </p>

            <div className="keyh-content pt-4">
              {json.map((item, index) => {
                return (
                  <div
                    className="appear-on-scroll content-wrapper"
                    key={`${index}`}
                  >
                    <Fade triggerOnce delay={index * 150}>
                      <div className="line">
                        <div className="">
                          <p className="title text-[1.3rem] md:text-[2.1vw] ">
                            <div className="w-fit text-content text-[var(--dark-blue)]">
                              {item.title}
                            </div>
                          </p>
                          <p
                            className="description w-full text-[1rem] md:text-[1.7vw]"
                            data-text={item.description}
                          >
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </Fade>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className=" w-full px-5 sm:px-24 pt-1 pb-5 md:pb-10 sm:my-14 gallery-section">
        <div className="py-4 sm:py-6">
          <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-white">
            <Fade triggerOnce className="h-full relative" delay={700}>
              Gallery
            </Fade>
          </p>
        </div>

        <div>
          <MultiCarousel
            data={videoData}
            responsiveSettings={responsive}
            carouselContainerClassname="video-carousel-container"
            listItemClassname="video-list-item"
          />
        </div>
      </div>

      <div className=" w-full px-5 sm:px-24 mt-6 sm:my-14">
        <div className="py-4 sm:py-6">
          <p className="text-center mb-4 md:mb-8 font-notosans text-3xl sm:text-4xl font-bold text-[#333e49]">
            <Fade triggerOnce className="h-full relative" delay={700}>
              Modules integrated in E-commerce Dashboard
            </Fade>
          </p>
        </div>

        <div>
          <div>
            <div className="modules-grid">
              {modules.map((obj, index) => {
                return (
                  <div
                    className="modules-card bg-[var(--dark-blue)]"
                    key={uniqueId()}
                  >
                    <Slide triggerOnce direction="up" delay={index * 40}>
                      <div className="img-wrap flex justify-center appear-on-scroll">
                        <img
                          src={obj.img}
                          alt="img"
                          className="bg-white border border-t border-b-0  border-gray-400 "
                        />
                      </div>
                      <div className="title text-center pb-2 pt-[4px] text-xs lg:text-lg tracking-widest font-semibold text-white">
                        {obj.title}
                      </div>
                    </Slide>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div>
          <Fade triggerOnce className="h-full relative" delay={700}>
            <ContactCTA />
          </Fade>
        </div>
      </div>

      <GotoTop />
    </div>
  );
};
const RenderVideo = ({ title, src, poster }) => {
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    setPlaying(true);
  };

  const closePreview = () => {
    setPlaying(false);
  };
  // --text-amber-600

  return (
    <>
      <div className="z-[2] video-title border-2 bg-[var(--dark-blue)] border-orange-400 min-w-[30ch] text-center pt-1 lg:pt-2 pb-1 text-xs lg:text-lg font-bold text-white absolute right-[-12ch] top-[1ch] tracking-wider rotate-45">
        {title}
      </div>
      <div className="video-wrapper relative overflow-hidden ">
        <img
          src={PlayIcon}
          alt="play"
          title="click to Play"
          className="play-icon absolute w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] bg-slate-200 rounded-[50vw] shadow-lg"
          onClick={handlePlay}
        />
        <img
          src={poster}
          alt="thumbnail"
          className="max-sm:min-h-[100px] max-sm:min-w-[150px]"
          title="click to Play"
          onClick={handlePlay}
        />
      </div>

      {playing && (
        <Dialog
          sx={{
            zIndex: "100000",
          }}
          open={playing}
          onClose={closePreview}
          maxWidth="lg"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <IconButton
            onClick={closePreview}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "black",
              backgroundColor: "white",
              border: "1px solid black",
              paddingInline: "10px",
              zIndex: 2,
            }}
          >
            <button className="leading-[1]" title="close">
              ✕
            </button>
          </IconButton>

          <div className="p-1 lg:p-6 bg-slate-200 overflow-visible">
            <div className="relative overflow-visible">
              <video src={src} controls muted />
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default EcommerceDashboard;
